module.exports = __webpack_public_path__ + "img/10.2c7778a6.jpg";